import 'cookieconsent';

function initCookieConsent(options) {
    window.addEventListener('load', () => {
        window.cookieconsent.initialise(options, () => {
            // In 3.0.4, cookieconsent applies the cc-floating class on mobile regardless of config
            if (options.position === 'bottom') {
                const el = document.querySelector('.cc-window');
                if (el.classList) {
                    el.classList.remove('cc-floating');
                    el.classList.add('cc-banner');
                } else {
                    el.className = el.className.replace(new RegExp(`(^|\\b)${'cc-floating'.split(' ').join('|')}(\\b|$)`, 'gi'), ' ');
                    el.className = `${el.className} cc-banner`;
                }
            }
        });
    });
}

export default {
    initCookieConsent,
};
